import { render, staticRenderFns } from "./AddSiteDetails.vue?vue&type=template&id=64118b67&"
import script from "./AddSiteDetails.vue?vue&type=script&lang=js&"
export * from "./AddSiteDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports